import script from "./NewsCardPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCardPreview.vue?vue&type=script&setup=true&lang=js"

import "./NewsCardPreview.vue?vue&type=style&index=0&id=04a4ec2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a4ec2a"]])

export default __exports__